import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps } from 'common';

export function usePatientQuery(props: { ehrInformationId: string }) {
  const { ehrInformationId } = props;
  const patientResult = useQuery({
    ...getQueryProps(api.client.Patient, 'findOneByEhrInformationId', ehrInformationId),
    retry: 0,
  });

  return patientResult;
}
